/* eslint-disable no-underscore-dangle,class-methods-use-this */
import _ from 'lodash';
import qs from 'qs';

const METHOD_GET = 'GET';

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  error.code = 100;
  throw error;
}

function objectToFormData(obj, form, namespace) {
  const fd = form || new FormData();
  Object.keys(obj).forEach((key) => {
    let formKey;
    if (namespace) {
      formKey = `${namespace}[${key}]`;
    } else {
      formKey = key;
    }
    const value = obj[key];
    if (value != null) {
      if (typeof value === 'object' && !(value instanceof File)) {
        objectToFormData(value, fd, formKey);
      } else {
        // if it's a string or a File object
        fd.append(formKey, value);
      }
    } else {
      fd.append(formKey, '');
    }
  });

  return fd;
}

class ApiInvoker {
  constructor() {
    this.handledInvalidToken = false;
    this.invalidTokenHandler = null;
    this.authFailedChecker = () => false;
    this.authMode = null;
  }

  setAuthMode(mode) {
    this.authMode = mode;
  }

  setInvalidTokenHandler(handler) {
    this.invalidTokenHandler = handler;
  }

  setAuthFailedChekcer(checker) {
    this.authFailedChecker = checker;
  }

  getRequestURL(url, data = {}, serverURL) {
    const baseURL = `${serverURL}/${url}`;
    const params = qs.stringify(data);
    return params ? `${baseURL}?${params}` : baseURL;
  }

  request = async (url, data = {}, options, serverURL) => {
    if (this.authMode) {
      _.assign(data, { mode_type: this.authMode });
    }
    const {
      method = METHOD_GET, noJSON, noStatusCode, dataType,
    } = options || {};
    let response;
    const headers = {
      Accept: 'application/json',
    };
    const reqMethod = dataType === 'form' ? 'PUT' : method.toUpperCase();
    if (!noJSON && dataType !== 'form' && reqMethod !== METHOD_GET) {
      headers['Content-Type'] = 'application/json';
    }
    const baseURL = `${serverURL}/${url}`;
    if (reqMethod === METHOD_GET) {
      const params = qs.stringify(data);
      const fetchURL = params ? `${baseURL}?${params}` : baseURL;
      response = await fetch(fetchURL, { headers, method });
    } else {
      response = await fetch(baseURL, {
        method: reqMethod,
        headers,
        body: dataType === 'form' ? objectToFormData(data) : JSON.stringify(data),
      });
    }

    await checkStatus(response);
    const text = await response.text();
    if (text) {
      let json = text;
      if (typeof text === 'string') {
        json = JSON.parse(text);
      }
      const code = Number(json.code);
      if (noStatusCode) {
        return json;
      } if (code === 200) {
        return json.data;
      }
      const error = new Error(json.msg);
      error.code = json.code;
      error.message = json.msg;
      throw error;
    }
    return null;
  };
}

export default new ApiInvoker();
